<template>
  <div class="about-page">
    <!-- 顶部标题条：标题来自后台「站点配置-关于我们」 -->
    <div class="page-hero">
      <div class="container">
        <h1>{{ config.about_title || '关于我们' }}</h1>
        <p>{{ config.site_description || '了解我们的公司与团队' }}</p>
      </div>
    </div>

    <div class="container content" v-loading="loading">
      <!-- 正文：后台富文本录入，本身即 HTML，用 v-html 渲染 -->
      <div v-if="config.about_content" class="article" v-html="config.about_content"></div>
      <el-empty v-else-if="!loading" description="关于我们内容暂未配置，请在后台管理系统「站点配置」中填写" />

      <!-- 联系方式卡片：有任何一个字段就显示 -->
      <div v-if="hasContact" class="contact-card">
        <h3 class="contact-title">联系我们</h3>
        <div class="contact-grid">
          <div v-if="config.phone" class="contact-item">
            <i class="el-icon-phone"></i>
            <div>
              <div class="label">电话</div>
              <div class="value">{{ config.phone }}</div>
            </div>
          </div>
          <div v-if="config.email" class="contact-item">
            <i class="el-icon-message"></i>
            <div>
              <div class="label">邮箱</div>
              <div class="value">{{ config.email }}</div>
            </div>
          </div>
          <div v-if="config.address" class="contact-item">
            <i class="el-icon-location"></i>
            <div>
              <div class="label">地址</div>
              <div class="value">{{ config.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSiteConfig } from '../api'

export default {
  name: 'About',
  data() {
    return {
      loading: true,
      config: {
        about_title: '',
        about_content: '',
        site_description: '',
        phone: '',
        email: '',
        address: ''
      }
    }
  },
  computed: {
    hasContact() {
      return !!(this.config.phone || this.config.email || this.config.address)
    }
  },
  created() {
    this.fetchConfig()
  },
  methods: {
    async fetchConfig() {
      this.loading = true
      try {
        const res = await getSiteConfig()
        this.config = { ...this.config, ...res.data }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.content { padding: 40px 0 60px; min-height: 300px; }

/* 富文本正文排版（与新闻详情一致） */
.article { font-size: 15px; line-height: 1.9; color: #303133; }
.article >>> img { max-width: 100%; }

.contact-card {
  margin-top: 40px;
  padding: 28px 32px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.contact-title {
  margin: 0 0 20px;
  font-size: 18px;
  color: #1f2d3d;
}
.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
}
.contact-item { display: flex; align-items: flex-start; gap: 12px; }
.contact-item i { font-size: 22px; color: #1677ff; margin-top: 2px; }
.label { font-size: 13px; color: #909399; }
.value { font-size: 15px; color: #303133; margin-top: 2px; }
</style>
